// Clients.js
import React from "react";
import TierEntity from "../Tiers/TierEntity";

const Clients = () => {
    return <TierEntity title="Clients" endpoint="Clients" />;
};

export default Clients;
